<template>
  <div class="layout-main">
    <div class="wp-con clearfix">
      <div class="official-left">
        <UserBox
          :xla="{
            show: 'bulletin_page_show',
            click: 'bulletin_page_user_module_click'
          }"
        />
        <ServerList
          :xla="{
            show: 'bulletin_page_server_module_show',
            click: 'bulletin_page_server_module_click',
            itemClick: 'bulletin_page_server_item_click'
          }"
        />
      </div>
      <div class="official-right">
        <div class="content-area notice-list">
          <div class="title">
            <span class="left">公告列表</span>
            <TitleRight
              :list="[
                '公告列表',
                `${resType({ res_type: this.$route.query.type })}`
              ]"
              @title-click="
                $xlaGamePush('bulletin_page_notice_module_click', {
                  click_id: 'bread_crumb'
                })
              "
            />
          </div>
          <div class="content">
            <div
              v-for="item in list"
              :key="item.id"
              class="item"
              @click="
                openRoute(`./${item.id}`)
                $xlaGamePush('bulletin_page_notice_item_click', {
                  text: item.title,
                  notice_id: item.id
                })
              "
            >
              [{{ resType(item) }}]{{ item.title }}
              <span class="time">{{ convertTime(item) }}</span>
            </div>
            <Panigition
              :page="pageNum"
              @change="
                getList($event, $route.query.type)
                $xlaGamePush('bulletin_page_notice_module_click', {
                  click_id: 'page_change'
                })
              "
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import UserBox from '~/components/game-offical/common/UserBox'
import ServerList from '~/components/game-offical/common/ServerList'
import Panigition from '~/components/common/Pagination'
import { ResType } from '~/constant'
import TitleRight from '~/components/game-offical/common/TitleRight'
export default {
  layout: 'game',
  components: {
    UserBox,
    ServerList,
    Panigition,
    TitleRight
  },
  data() {
    return {
      list: [],
      page: 0,
      pageNum: 1
    }
  },
  created() {
    if (process.client) {
      this.getList(1, this.$route.query.type)
    }
  },
  watchQuery: ['server_id'],
  beforeRouteUpdate(to, from, next) {
    this.getList(1, to.query.type)
    next()
  },
  mounted() {
    this.$xlaGamePush('bulletin_page_show')
    this.$xlaGamePush('bulletin_page_notice_module_show')
  },
  methods: {
    getList(page, res_type = 0) {
      this.$request('gameHomeRes', {
        body: {
          game_id: this.$route.params.game_id,
          res_type,
          page,
          page_size: 15
        }
      }).then((data = {}) => {
        this.list = data.list || []
        this.pageNum = Math.ceil(data.total_count / 15)
      })
    },
    resType({ res_type }) {
      return ResType[res_type]
    },
    openRoute(path) {
      const _url = path
      const routeUrl = this.$router.resolve({
        path: _url
      })
      window.open(routeUrl.href, '_blank')
    },
    convertTime({ published_at }) {
      return dayjs(published_at).format('MM-DD')
    }
  }
}
</script>
